import React from 'react'

export default function Satellite() {
  return (
    <div>Satellite</div>
  )
}
